import Collection from "./components/Collection";
import loadCss from "@mrg_minigames/common/css_loader/loadMinigameCss";
import * as store_modules from "../../../model/store";
import registerStoreModules from "@mrg_minigames/common/helpers/store/registerStoreModules";
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";

import registerMinigameVuePlugin from "@mrg_minigames/common/helpers/plugin/registerMinigameVuePlugin";
import registerLocale from "@mrg_minigames/common/localization/registerLocale";

import Notifications from "vue-notification";

// Register local minigame api
import MinigameCollectionApi from "../../../model/api/CollectionApi";
import StoreServiceApi from "@chronos/frontend-base/src/libs/api/services/StoreServiceApi";

const plugin = {
  //site should provide store option when call Vue.use, example: Vue.use(plugin, {store});
  install(VueInstance, options) {
    const { store, i18n } = options;
    loadCss(); //dynamically load minigame styles
    window.api.registerService(MinigameCollectionApi.name, MinigameCollectionApi);
    window.api.registerService(StoreServiceApi.name, StoreServiceApi);

    VueInstance.use(Notifications);

    VueInstance.component("Collection", Collection); //register basic minigame component
    VueInstance.prototype.$s = getStoreModuleByName;
    registerStoreModules(store_modules, store);
    registerLocale(i18n);
  },
};
registerMinigameVuePlugin(plugin);

export default plugin;
